import { StateCreator } from 'zustand'

import { AppTourKeys } from '../../constants'

// Use the values of AppTourKeys as the keys for the state
export type AppTourState = {
  [_K in (typeof AppTourKeys)[keyof typeof AppTourKeys]]: boolean
}

const defaultState: AppTourState = {
  [AppTourKeys.DashboardGrid]: false,
  [AppTourKeys.FosterProfileTab]: false,
  [AppTourKeys.FosterHealthTab]: false,
  [AppTourKeys.FosterGridAdvancedFilter]: false,
  [AppTourKeys.FosterGridBasicFilter]: false,
  [AppTourKeys.FosterAdoptionTab]: false,
  [AppTourKeys.FosterDocumentsTab]: false,
  [AppTourKeys.PushNotificationModal]: false,
  [AppTourKeys.MedicationChangeModal]: false,
}

export interface AppTourSlice {
  appTour: AppTourState
  setAppTourStepComplete: (
    key: (typeof AppTourKeys)[keyof typeof AppTourKeys],
    complete: boolean
  ) => void
  resetAppTour: () => void
  hasSeenWelcomeModal: boolean
  setHasSeenWelcomeModal: (seen: boolean) => void
  hasSeenPushNotificationModal: boolean
  setHasSeenPushNotificationModal: (seen: boolean) => void
}

export const createAppTourSlice: StateCreator<AppTourSlice> = (set) => ({
  appTour: defaultState,
  setAppTourStepComplete: (key, complete) => {
    set((state) => {
      const updatedAppTour = {
        ...state.appTour,
        [key]: complete,
      }

      if (
        key === AppTourKeys.FosterHealthTab &&
        complete &&
        !state.appTour[AppTourKeys.MedicationChangeModal]
      ) {
        updatedAppTour[AppTourKeys.MedicationChangeModal] = true
      }

      return {
        appTour: updatedAppTour,
      }
    })
  },
  resetAppTour: () => {
    set({
      appTour: { ...defaultState },
      hasSeenWelcomeModal: false,
      hasSeenPushNotificationModal: false,
    })
  },
  hasSeenWelcomeModal: false,
  setHasSeenWelcomeModal: (seen) => set({ hasSeenWelcomeModal: seen }),
  hasSeenPushNotificationModal: false,
  setHasSeenPushNotificationModal: (seen) =>
    set({ hasSeenPushNotificationModal: seen }),
})
